export default {
  API_ENDPOINT:
    process.env.NODE_ENV === 'production'
      ? 'https://stockwits-viewers.herokuapp.com/api'
      : 'http://localhost:8001/api',
};
